import { VITE_ROUTER_BASENAME } from "@/env";

export const BASE_URL = VITE_ROUTER_BASENAME;

export const ADMIN_MENU = [
  {
    title: "Inicio",
    label: "Inicio",
    icon: "squares",
    href: BASE_URL,
  },
  {
    title: "Listado de fotos",
    label: "Fotos",
    icon: "photos",
    href: "photos",
  },
  {
    title: "Peticiones de borrado de fotos",
    label: "Peticiones",
    icon: "pending",
    href: "requests",
  },
];

export const TMA_MENU = [
  {
    title: "Inicio",
    label: "Inicio",
    icon: "squares",
    href: BASE_URL,
  },
  {
    title: "Listado de fotos",
    label: "Fotos",
    icon: "photos",
    href: "photos",
  },
];

export const RECEPTION_INITIAL_STATE = {
  step: "",
  customerOrderNoserv: "",
  serialIn: "",
  orderIn: "",
};

export const EXITS_INITAL_STATE = {
  area: "send",
  step: "",
  document9r1: "",
  orderOut: "",
  serialOut: "",
  customer: "",
  packagingReference: "",
};
export const CONFIGURATION = {
  FINDINGS_NACELLE: "findings_nacelle",
};

export const NACELLE_CONFIGURATION = {
  FINDINGS: "Findings",
  GARAGE_ID: "TGQEC000",
};

export const ImageDeletionRequestStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const ADMIN_PROFILES = [
  "GENERAL_ADMIN",
  "MRO_FDC_SUPERVISOR",
  "MRO_SUPERVISOR",
  "MRO_SUPERVISOR_COMPONENTS",
  "MRO_ADMIN",
];

export const TMA_PROFILES = ["MRO_FDC_TMA", "MRO_TMA", "MRO_TMA_COMPONENTS"];

export const DEFAULT_LIMIT = "10";
export const LIMITS = [
  {
    label: "10",
    value: "10",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "30",
    value: "30",
  },
  {
    label: "40",
    value: "40",
  },
  {
    label: "50",
    value: "50",
  },
];
